import { snapToGrid } from '../../../../../../utils/layouts/snapToGrid';

interface DragBoundParams {
  position: { x: number; y: number };
  snapEnabled: boolean;
  gridX: number;
  gridY: number;
  gapX: number;
  gapY: number;
  scaleX: number;
  scaleY: number;
  maxX: number;
  maxY: number;
}

// The drag position is in absolute pixels — converted to canvas units for the
// live grid snap, and the canvas limits are scaled by the stage zoom to
// compare. Snapping while dragging pins the top-left corner to the nearest
// rendered grid dot (dragEnd then just confirms it).
export const getDragBoundPosition = ({
  position,
  snapEnabled,
  gridX,
  gridY,
  gapX,
  gapY,
  scaleX,
  scaleY,
  maxX,
  maxY,
}: DragBoundParams): { x: number; y: number } => {
  const rawX = position.x / scaleX;
  const rawY = position.y / scaleY;
  const snappedX = snapEnabled ? snapToGrid(rawX, gridX, gapX) : rawX;
  const snappedY = snapEnabled ? snapToGrid(rawY, gridY, gapY) : rawY;

  return {
    x: Math.min(Math.max(snappedX * scaleX, 0), maxX * scaleX),
    y: Math.min(Math.max(snappedY * scaleY, 0), maxY * scaleY),
  };
};
